import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useConfig } from "../context/ConfigContext";
import { Layout } from "../components/Layout";
import api from "../lib/api";
import FamilyDashboard from "../components/dashboards/FamilyDashboard";
import AgencyDashboard from "../components/dashboards/AgencyDashboard";
import AdminDashboard from "../components/dashboards/AdminDashboard";
import SubcontractorDashboard from "../components/dashboards/SubcontractorDashboard";
import WorkforceComplianceDashboard from "../components/dashboards/WorkforceComplianceDashboard";
import SubscribeBanner from "../components/SubscribeBanner";

export default function DashboardPage() {
  const { user } = useAuth();
  const { phiEnabled } = useConfig();
  const [documents, setDocuments] = useState([]);
  const [docTotal, setDocTotal] = useState(0);
  const [docLimit, setDocLimit] = useState(20);
  const [stats, setStats] = useState(null);

  const refresh = useCallback(async () => {
    const [docsRes, statsRes] = await Promise.all([
      api.get("/documents", { params: { limit: docLimit } }),
      api.get("/stats"),
    ]);
    setDocuments(docsRes.data.items);
    setDocTotal(docsRes.data.total);
    setStats(statsRes.data);
  }, [docLimit]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // Poll while any document is still processing
  useEffect(() => {
    if (!documents.some((d) => d.status === "processing")) return;
    const t = setInterval(refresh, 4000);
    return () => clearInterval(t);
  }, [documents, refresh]);

  const props = { user, documents, stats, refresh, docTotal, loadMore: () => setDocLimit((l) => l + 20) };

  return (
    <Layout>
      <SubscribeBanner role={user.role} />
      {!phiEnabled && (user.role === "agency" || user.role === "admin") && (
        <WorkforceComplianceDashboard user={user} />
      )}
      {phiEnabled && user.role === "family" && <FamilyDashboard {...props} />}
      {phiEnabled && user.role === "agency" && <AgencyDashboard {...props} />}
      {phiEnabled && user.role === "admin" && <AdminDashboard {...props} />}
      {user.role === "family" && !phiEnabled && (
        <p className="text-center text-sm text-[#57605A] py-12">
          Family portal is paused in this version of Nexari Health.
        </p>
      )}
      {user.role === "subcontractor" && <SubcontractorDashboard {...props} />}
    </Layout>
  );
}
